module.exports = __webpack_public_path__ + "static/media/sellersignupimg.ec0ac4eb.png";